import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const GoogleIcon = React.forwardRef<SVGSVGElement, SvgIconProps & { disabled?: boolean }>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="social/google" ref={ref as any} {...props}>
      <path
        d="M12.1834 5.93756C14.0956 5.93756 15.3854 6.76354 16.1209 7.45374L18.9949 4.64767C17.2298 3.00702 14.9329 2 12.1834 2C8.20054 2 4.76084 4.28559 3.08624 7.61215L6.37885 10.1693C7.20484 7.71398 9.49043 5.93756 12.1834 5.93756V5.93756Z"
        fill={props.disabled ? 'currentColor' : '#EA4335'}
      />
      <path
        d="M21.9593 12.4098C21.9593 11.5725 21.8915 10.9615 21.7444 10.3279H12.1833V14.107H17.7955C17.6823 15.0462 17.0713 16.4605 15.7136 17.411L18.927 19.9002C20.8505 18.1238 21.9593 15.5101 21.9593 12.4098V12.4098Z"
        fill={props.disabled ? 'currentColor' : '#4285F4'}
      />
      <path
        d="M6.39015 14.1973C6.17517 13.5637 6.0507 12.8848 6.0507 12.1832C6.0507 11.4817 6.17517 10.8028 6.37883 10.1692L3.08622 7.61206C2.39602 8.99247 2 10.5426 2 12.1832C2 13.8239 2.39602 15.374 3.08622 16.7544L6.39015 14.1973V14.1973Z"
        fill={props.disabled ? 'currentColor' : '#FBBC05'}
      />
      <path
        d="M12.1833 22.3666C14.9328 22.3666 17.2411 21.4614 18.927 19.8999L15.7136 17.4107C14.8536 18.0104 13.6995 18.429 12.1833 18.429C9.4904 18.429 7.20481 16.6526 6.39015 14.1973L3.09753 16.7544C4.77213 20.081 8.20052 22.3666 12.1833 22.3666V22.3666Z"
        fill={props.disabled ? 'currentColor' : '#34A853'}
      />
    </SvgIcon>
  );
});
